<template>
  <div class="applyAudit">
    <template v-if="isApplyAudit">
      <ots-tipline :isTopLine="true" v-show="isCanHandle">
        当前批次报名审核截止时间为<span>{{ endAuditTime }}</span>
        ,请尽快完成审核
      </ots-tipline>
      <ots-tipline :isTopLine="true" v-show="examineNumbers">
        当前存在<span>{{ examineNumbers }}</span>
        条待审核数据
      </ots-tipline>
      <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>
      <ots-table-group-new
        ref="ots-table"
        :selectList="teaSelectList"
        :requestForm="requestForm"
        @search="search"
        :tableHeader="tableHeader"
        :tableData="tableData"
        :tableOption="tableOption"
        :batchOperBtn="batchOperBtn"
        :isDisabledMultiple="isDisabledMultiple"
        @handleSelectionChange="bachOper"
        :pagination="pagination"
        @changeNum="changeNum"
        @changePage="changePage"
        @changeCity="changeCityFN"
      ></ots-table-group-new>
      <ots-custom-dialog :dialog.sync="applyMsgDialog" title="报名信息审核">
        <template v-slot:content>
          <div class="exportDialog">
            <el-form ref="exportForm">
              <el-form-item label="驳回原因">
                <el-input type="textarea" v-model="ruleForm.reason"></el-input>
              </el-form-item>
              <el-form-item label="重新提交报考信息">
                <el-radio-group v-model="ruleForm.flag">
                  <el-radio-button :label="0">允许</el-radio-button>
                  <el-radio-button :label="1">不允许</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-form>
          </div>
        </template>
        <template v-slot:footer>
          <el-button round @click="applyMsgDialog = false">取消</el-button>
          <el-button round type="primary" @click="rightAudit">确定</el-button>
        </template>
      </ots-custom-dialog>
    </template>

    <template v-else>
      <router-view></router-view>
    </template>
    <ots-custom-dialog
      :dialog.sync="importDialog"
      title="导入审核信息"
      width="40%"
    >
      <template v-slot:content>
        <div class="exportDialog">
          <el-form ref="exportForm" :model="importForm">
            <el-form-item label="1.模板下载说明">
              <span>
                可先根据查询条件导出所需的数据，修改后进行上传。
              </span>
            </el-form-item>
            <el-form-item label="2.选择文件" v-model="importForm.file">
              <ots-upload-file :httpRequest="handleFormData" fileType="xlsx" />
            </el-form-item>
          </el-form>
          <div class="impExplain">
            <span class="tipTitle"><i></i>提示：</span>
            <div>
              <div>
                1：只能上传扩展名为<span class="col_red">.xlsx</span>的文件；
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="importDialog = false">取消</el-button>
        <el-button round type="primary" @click="rightImport">确定</el-button>
      </template>
    </ots-custom-dialog>

    <ots-custom-dialog
      :dialog.sync="exemptFileDialog"
      title="查看免考材料"
      width="60%"
    >
      <template v-slot:content>
        <div style="width: 70%; margin: 16px auto;">
          <p style="margin-bottom: 8px;">免考课程：{{exemptData.courseName}}</p>
          <p style="margin-bottom: 8px;">免考原因：{{exemptData.reasonName}}</p>
          <p style="margin-bottom: 8px;">免考材料证明网站：{{exemptData.reasonProveText}}</p>
          <ul class="showFile">
          <li v-for="item in exemptData.fileList" :key="item.id" @click="openApplyFile(item.url)">
            <img :src="item.fileext == 'pdf'? defaultUrl: item.url" alt="">
            <p>{{ item.filename }}</p>
          </li>
        </ul>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="exemptFileDialog = false">关闭</el-button>
        <!-- <el-button round type="primary" @click="exemptFileDialog = false">确定</el-button> -->
      </template>
    </ots-custom-dialog>

    <ots-custom-dialog
      :dialog.sync="studentFileDialog"
      title="查看报名材料"
      width="60%"
    >
      <template v-slot:content>
        <div style="width: 70%; margin: 16px auto;">
          <ul class="showFile">
            <li v-for="item in studentFileList" :key="item.id" @click="openApplyFile(item.url)">
              <img :src="defaultUrl" alt="" v-if="item.fileext == 'pdf'">
              <img :src="wordDefaultUrl" alt="" v-else-if="item.fileext == 'doc' || item.fileext == 'docx'">
              <img :src="item.url" alt="" v-else>
              <p>{{ item.filename }}<br><br>
                <span v-if="item.agentResultCode > -1 " style="color: red;">AI初审结果：</span>
                <span v-if="item.agentResultCode > -1 " style="color: cadetblue;">{{ item.agentResultDesc }}</span>
              </p>
            </li>
          </ul>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="studentFileDialog = false">取消</el-button>
        <el-button round type="primary" @click="studentFileDialog = false">确定</el-button>
      </template>
    </ots-custom-dialog>

  </div>
</template>

<script>
import moment from "moment";
import { getStudentCourseExemptListAPI, exportStudentCourseExemptFileAPI, getPlanCourseExemptScopeAPI } from '@/http/modules/baseSet/course'

import {
  getSinglePlan,
  getCurrentPlanFn,
  getSelectPlanFn,
  RegisterForm
} from "@/http/modules/examSet/examBatch";
import {
  examineList,
  exportExamine,
  getExamineNumber,
  getPlanCourseList,
  planFileSetListAPI,
  studentFilesListAPI,
  exportStudentFilesAPI
} from "@/http/modules/custom";
import { getReasonListAPI } from "@/http/modules/examSet/score";

export default {
  name: "applyAudit",
  data() {
    return {
      defaultUrl: require("@/assets/img/PDFIcon.png"),
      wordDefaultUrl: require("@/assets/img/WORDIcon.jpg"),
      currentPlanId: "",
      importDialog: false,
      mainTopBtnList: [
        {
          title: "导出",
          fn: this.exportInfo,
        },
        {
          title: "报名材料导出",
          plain: true,
          notShow: true,
          fn: this.exportStudentFile,
        },
      ],
      endAudit: "",
      endAuditTime: "",
      applyMsgDialog: false,
      ruleForm: {
        isAudit: 2,
        flag: 0,
        reason: "",
        planId: "",
        state: 0,
        stuId: "",
      },
      requestForm: {
        page: 1,
        isAudit: 2,
        size: 10, //每页条数
        planId: "", //批次Id
        schoolId: "", // 学校
        stationId: [""], // 教学点
        orders: "",
        stateType: "3", // 审核状态--默认待终审
        photoState: "", // 人身核验状态
        searchKey: "",
        phone: "",
        email: "",
        courseId:'',
        exemptExam: "",
        exemptReasonId: "",
      },
      stuIds: [],
      teaSelectList: [
        {
          title: "考试批次",
          type: "select",
          requestKey: "planId",
          isSearch: true,
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "审核状态",
          type: "select",
          requestKey: "stateType",
          label: "name",
          value: "id",
          data: [
            {
              id: "",
              name: "全部",
            },
            {
              id: "3",
              name: "待终审",
            },
            {
              id: "4",
              name: "终审通过",
            },
            {
              id: "5",
              name: "终审不通过",
            },
          ],
        },
        {
          title: "人身核验状态",
          type: "select",
          isSearch: true,
          requestKey: "photoState",
          label: "name",
          value: "id",
          data: [
            {
              id: "",
              name: "全部",
            },
            {
              id: 1,
              name: "系统通过",
            },
            {
              id: 0,
              name: "系统不通过",
            },
            {
              id: 2,
              name: "人工通过",
            },
            {
              id: 4,
              name: "无基础照片",
            },
            {
              id: 3,
              name: "无报名照片",
            }
          ],
        },
        {
          title: "院校",
          type: "select",
          isSearch: true,
          requestKey: "schoolId",
          label: "name",
          value: "id",
          data: [
            {
              id: "",
              name: "全部",
            },
          ],
        },
        {
          title: "教学点",
          type: "select",
          isSearch: true,
          multiple: true,
          requestKey: "stationId",
          label: "name",
          value: "id",
          data: [
            {
              id: "",
              name: "全部",
            },
          ],
        },
        {
          title: "关键词",
          type: "input",
          requestKey: "searchKey",
          placeholder: "姓名/证件号",
        },
        {
          title: "报考课程",
          type: "select",
          requestKey: "courseId",
          label: "courseName",
          value: "courseId",
        },
        {
          title: "手机号",
          type: "input",
          requestKey: "phone",
          placeholder: "请输入",
        },
        {
          title: "邮箱",
          type: "input",
          requestKey: "email",
          placeholder: "请输入",
        },
        {
          title: "是否申请免考",
          type: "select",
          requestKey: "exemptExam",
          label: "name",
          value: "id",
          notShow: true,
          data: [
            { id: "", name: "全部" },
            { id: 1, name: "是" },
            { id: 0, name: "否" },
          ]
        },
        {
          title: "免考原因",
          type: "select",
          requestKey: "exemptReasonId",
          label: "name",
          value: "id",
          notShow: true,
          data: [
            {id: "",name: "全部"},
          ],
        },
      ],
      tableHeader: [
        {
          title: "姓名",
          prop: "realName",
          width: "80",
          fixed: "left",
        },
        {
          title: "院校",
          prop: "school",
          width: "150",
        },
        {
          title: "教学点",
          prop: "station",
          width: "150",
        },
        {
          title: "证件号",
          prop: "cardNo",
          width: "150",
        },
        {
          title: "手机号",
          prop: "phone",
          width: "115",
        },
        {
          title: "邮箱",
          prop: "email",
          width: "160",
        },
        {
          title: "报考课程",
          prop: "course",
          width: "100",
        },
        {
          title: "首次报名日期",
          prop: "firstSignDate",
          width: "120"
        },
        {
          title: "基础照片",
          type: "img",
          prop: "photo",
          fixed: "right",
          width: "120"
        },
        {
          title: "报名照片",
          type: "img",
          prop: "photoUrl",
          fixed: "right",
          width: "120"
        },
        {
          title: "人身核验状态",
          prop: "photoState",
          type: "state",
          stateFlag: (scope) => {
            const options = {
              人工通过: "green",
              系统通过: "green",
              系统不通过: "red",
              无报名照片: "red",
            };
            return options[scope.row.photoState];
          },
          width: "120",
          fixed: "right",
        },
        {
          title: "审核状态",
          prop: "stateType",
          type: "state",
          stateFlag: (scope) => {
            //待初审、初审不通过、待终审、终审通过、终审不通过
            const options = {
              待初审: "orange",
              初审不通过: "red",
              待终审: "orange",
              终审通过: "green",
              终审不通过: "red",
            };
            return options[scope.row.stateType];
          },
          fixed: "right",
          width: "110",
        },
        {
          title:'报名登记表',
          type: "buttons",
          btnList: [
            {
              title: (val) =>{
                if(val.row.stateType == '终审通过'){
                  return '下载'
                }else{
                  ""
                }
              },
              click:this.lonwexcel,
            },
          ],
          width: "110",
        },
        {
          title: "免考材料",
          type: "button",
          prop: "exempt",
          formatter: (val) => "查看",
          fixed: "right",
          width: "120px",
          notShow: true,
          disableFn: (scope) => {
            if (scope.row.exemptExam == 1) {
              return false;
            } else {
              return true;
            }
          },
          click: this.showExemptFile,
        },
        {
          title: "免考原因",
          prop: "exemptReasonName",
          width: "120px",
          fixed: "right",
          notShow: true,
        },
        {
          title: "报名材料",
          type: "button",
          prop: "stuFile",
          formatter: (val) => "查看",
          fixed: "right",
          width: "120px",
          notShow: false,
          disableFn: (scope) => {
            if (scope.row.uploadFileCount > 0) {
              return false;
            } else {
              return true;
            }
          },
          click: this.showStuFile,
        },

        {
          title: "操作",
          type: "buttons",
          width: "165",
          fixed: "right",
          btnList: [
            {
              title: "通过",
              formatter: (scope) => {
                let { stateType } = scope.row;
                return !(stateType === "待终审" && this.isCanHandle);
              },
              click: this.pass,
            },
            {
              title: "驳回",
              formatter: (scope) => {
                let { stateType } = scope.row;
                return !(stateType === "待终审" && this.isCanHandle);
              },
              click: this.unpass,
            },
            {
              title: "撤销审核",
              formatter: (scope) => {
                let { stateType } = scope.row;
                if (
                  (stateType === "终审通过" || stateType === "终审不通过") &&
                  this.isCanHandle
                ) {
                  return false;
                } else {
                  return true;
                }
              },
              click: this.revokeState,
            },
            {
              title: "审核详情",
              click: this.lookDetail,
            },
          ],
        },
      ],
      tableData: [],
      tableOption: {
        multiple: true,
      },
      batchOperBtn: [
        {
          title: "批量审核通过",
          icon: "iconfont icon-kaiqi",
          click: this.exportUser,
        },
        {
          title: "批量下载免考材料",
          icon: "iconfont icon-daochu",
          click: this.exportExempt,
          notShow: true,
          name: "exempt"
        }
      ],
      pagination: {
        total: 0,
      },
      importForm: {
        file: "",
      },
      customSearch: [],
      currentTime: "",
      examineNumbers: 0,
      exemptFileDialog: false,
      exemptData: {},
      isNotShowFlag: true,
      planInfo: {},

      studentFileList: [],
      studentFileDialog: false,
    };
  },
  computed: {
    isApplyAudit() {
      return this.$route.name === "applyAudit";
    },
    isOverAudit() {
      return (
        new Date(this.currentTime).getTime() >
        new Date(this.endAuditTime).getTime()
      );
    },
    isCurrentPlan() {
      return this.requestForm.planId == this.currentPlanId;
    },
    isCanHandle() {
      // return !this.isOverAudit && this.isCurrentPlan;
      return !this.isOverAudit;
    },
  },
  watch: {
    $route: function(val) {
      if (val.name == "applyAudit") {
        this.getTableList();
      }
    },
    "requestForm.planId": function(val) {
      this.isPlanChange = true;
      this.search();
      this.setCurrentPlanId();
      this.getPlanCourse(val)
      this.isShowExempt(val);
      this.isShowStudentFile(val);
    },
  },
  mounted() {
    this.getData();
    this.isSetState();
    this.examineNumber();
  },
  methods: {
    /********************************
     * @param { 报名材料：是否显示报名材料表格列 }
     ********************************/
    async isShowStudentFile(planId) {
      const { data } = await planFileSetListAPI({planId});
      let flag = data.length > 0;
      this.mainTopBtnList[1].notShow = !flag;
      this.tableHeader.map(e => {
        if (e.prop == "stuFile") {
          e.notShow = !flag;
        }
      })
    },

    /********************************
     * @param { 报名材料：查看详情 }
     ********************************/
    async showStuFile(row) {
      let params = {
        planId: this.requestForm.planId,
        stuUserId: row.stuid
      }
      const { data } = await studentFilesListAPI(params);
      this.studentFileList = data;
      this.studentFileDialog = true;
    },

    /********************************
     * @param { 报名材料：导出 }
     ********************************/
    async exportStudentFile() {
      let params = { ...this.requestForm };
      params.stationId = params.stationId.join(",");
      delete params.page;
      delete params.size;
      const { code, data } =  await exportStudentFilesAPI(params);
      if (code && data) {
        window.open(data);
      }
    },


    // 免考
    async isShowExempt(planId) {
      const { data } = await getPlanCourseExemptScopeAPI({planId});
      let flag = data.length > 0;
      this.isNotShowFlag = !flag;
      this.tableHeader.map(e => {
        if (e.prop == "exempt" || e.prop == "exemptReasonName") {
          e.notShow = !flag;
        }
      })

      this.teaSelectList.map(e => {
        if (e.requestKey == "exemptExam" || e.requestKey == "exemptReasonId") {
          e.notShow = !flag;
          return;
        }
      })

      this.batchOperBtn.map(e=> {
        if (e.name == "exempt") {
          e.notShow = !flag;
          return;
        }
      })
    },

    // 批量导出免考材料
    async exportExempt() {
      let params = { ...this.requestForm };
      if (typeof params.stationId == "object") {
        params.stationId = params.stationId.join(",");
      }
      delete params.page;
      delete params.size;
      const { data, code } =  await exportStudentCourseExemptFileAPI(params)
      if (code) {
        window.open(data);
      }
    },

    // 查看免考材料
    async showExemptFile(row) {
      let params = {
        planId: this.requestForm.planId,
        studentUserId: row.stuid
      }
      const { data } = await getStudentCourseExemptListAPI(params);
      this.exemptData = data[0];
      this.exemptFileDialog = true;
    },

    openApplyFile(val) {
      window.open(val);
    },


    lonwexcel(row){
    
     RegisterForm({
        stuIds:row.stuid,
        planId:row.planId,
      }).then((data)=>{
        if(data){
        window.open(data.data)
      }
      })
      
    },
    examineNumber() {
      getExamineNumber({
        isAudit: 2,
      }).then((res) => {
        if (res.code === 1) {
          this.examineNumbers = res.data;
        }
      });
    },
    /***********************************
     * @isSetState 系统是否设置了教学点标题
     ***********************************/
    isSetState() {
      this.mixin_getServerTime().then((res) => {
        if (res.code == 1) {
          this.currentTime = res.data;
        }
      });
      this.teaSelectList[4].title = "教学点";
      this.tableHeader[2].title = "教学点";
    },

    /*****************************************
     * @changeCityFN 子组件传递方法,地址数据处理
     *****************************************/
    changeCityFN(e, attr) {
      this.requestForm[attr] = e.toString();
    },

    /**
     * @param { 所选批次信息 }
     */
    async getPlanInfo(planId) {

      const { data } = await getSinglePlan({ planId });
      // (1) 审核提示
      this.endAuditTime = data.endAudit;
      this.isPlanChange = false;
      // (2) 表格"基础照片"配置
      let { photoContrastType } = data;
      if (photoContrastType === 2) {
        this.teaSelectList.map( e=> {
          if (e.requestKey === "photoState" && e.data[4].id != 4) {
            let item = { id: 4, name: "无基础照片" };
            e.data.splice(4, 0, item);
            return;
          }
        })

        if (this.tableHeader[8].prop !== "photo") {
          let item = {
            prop: "photo",
            title: "基础照片",
            type: "img",
            fixed: "right",
            width: "120"
          };
          this.tableHeader.splice(8, 0, item);
        }
      } else {
        this.teaSelectList.map( e=> {
          if (e.requestKey === "photoState" && e.data[4].id == 4) {
            e.data.splice(4, 1);
            return;
          }
        })

        if (this.tableHeader[8].prop === "photo") {
          this.tableHeader.splice(8, 1);
        }
      }
// weu_0314
    },

    revokeState(row) {
      let { planId, stuid } = row;
      this.$confirm("确定要撤销审核吗？", "撤销审核", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return this.$api.applyAudit.backExamineFn({
            isAudit: 2,
            planId,
            stuId: stuid,
          });
        })
        .then((res) => {
          if (res.code) {
            this.$message.success("撤销成功");
            this.getTableList();
          }
        })
        .catch(() => {});
    },
    exportInfo() {
      let params = { ...this.requestForm };
      if (typeof params.stationId == "object") {
        params.stationId = params.stationId.join(",");
      }

      exportExamine(params).then((res) => {
        if (res.code == 1) {
          window.location.href = res.data;
        }
      });
    },
  
    importInfo() {
      this.importDialog = true;
    },
    handleFormData(val) {
      this.importForm.file = val.file;
    },
    rightImport() {
      if (!this.importForm.file) {
        this.$message.error("请选择文件");
        return;
      }
      const fd = new FormData();
      for (let item in this.importForm) {
        fd.append(item, this.importForm[item]);
      }
      this.$api.applyAudit.importStudentStatus(fd).then((res) => {
        if (res.code == 1) {
          let data = res.data;
          const failNum = data.errorCount ? parseInt(data.errorCount) : 0;
          const totalNum = parseInt(data.allCount);
          const successNum = totalNum - failNum;

          let message = `导入完成，成功导入${successNum}，失败人员数${failNum}`;
          this.importDialog = false;

          this.$confirm(message, "导入结果", {
            confirmButtonText: failNum > 0 ? "查看错误记录" : "确定",
            cancelButtonText: "取消",
            type: failNum > 0 ? "warning" : "success",
          })
            .then(async () => {
              if (failNum > 0) {
                window.location.href = data.address;
              }
            })
            .catch(() => {});
          this.getTableList();
        }
      });
    },
    isDisabledMultiple(row) {
      let { stateType } = row;
      if (stateType == "待终审" && this.isCanHandle) {
        return true;
      }
      return false;
    },
    getTableList() {
      for (let key in this.requestForm) {
        if (this.requestForm[key] == "全部") {
          this.requestForm[key] = "";
        }
      }
      if (this.isPlanChange) {
        this.getPlanInfo(this.requestForm.planId);
      }

      let params = { ...this.requestForm };
      if (typeof params.stationId == "object") {
        params.stationId = params.stationId.join(",");
      }

      examineList(params).then((res) => {
        if (res.code) {
          this.tableData = res.data.records;
          this.pagination.total = res.data.total;
          res.data.records.forEach((e) => {
            e.extData.forEach((item) => {
              e[item.name] = item.value;
            });
          });
        }
      });
    },
    bachOper(val) {
      this.stuIds = [];
      let idList = [];
      val.forEach((item) => {
        idList.push(item.stuid);
      });
      this.stuIds = idList;
    },
    exportUser() {
      if (this.stuIds.length < 1) {
        this.$message({
          message: "请选择要通过的学生",
          type: "warning",
        });
        return;
      }
      this.$confirm(`确认将选中${this.stuIds.length}名学生审核通过`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let queryImport = {
            isAudit: 2,
            planId: this.requestForm.planId,
            stuIds: this.stuIds + "",
          };
          this.$api.applyAudit.batchExamine(queryImport).then((res) => {
            if (res.code) {
              this.$message({
                message: "审核通过",
                type: "success",
              });
              this.getTableList();
            }
          });
        })
        .catch(() => {});
    },
    search() {
      this.requestForm.page = 1;
      this.getTableList();
    },
    changeNum(num) {
      this.requestForm.size = num;
      this.getTableList();
    },
    changePage(p) {
      this.requestForm.page = p;
      this.getTableList();
    },
    examine() {
      this.$api.applyAudit.examine(this.ruleForm).then((res) => {
        if (res.code) {
          this.applyMsgDialog = false;
          this.$message({
            message: this.ruleForm.state ? "审核不通过" : "审核通过",
            type: this.ruleForm.state ? "error" : "success",
          });
          this.getTableList();
        }
      });
    },
    pass(val) {
      let { planId, stuid } = val;
      this.ruleForm.planId = planId;
      this.ruleForm.stuId = stuid;
      this.ruleForm.state = 0;
      this.examine();
    },
    unpass(val) {
      (this.ruleForm = {
        isAudit: 2,
        flag: 0,
        reason: "",
        planId: "",
        state: 1,
        stuId: "",
      }),
        (this.applyMsgDialog = true);
      let { planId, stuid } = val;
      this.ruleForm.planId = planId;
      this.ruleForm.stuId = stuid;
    },
    rightAudit() {
      this.examine();
    },
    lookDetail(val) {
      let { planId, stuid } = val;
      this.$router.push({
        path: "/applyAudit/applyAuditDetail",
        query: { planId, stuid, isCanHandle: this.isCanHandle },
      });
    },

    /*******************************************
     * @getData 配置表单下拉列表数据
     *******************************************/
    getData() {
      let typeList = [
        "select",
        "province",
        "subject",
        "nation",
        "politicalStatus",
        "level",
      ];
      this.mixin_setUserExtInfo().then((res) => {
        res.data.map((item) => {
          if (item.queryCondition == 1) {
            if (typeList.includes(item.type)) {
              if (item.valueVo) {
                let search = {
                  title: item.displayName,
                  type: "select",
                  requestKey: item.name,
                  label: "name",
                  value: "name",
                  data: [{ name: "全部" }, ...item.valueVo],
                };
                this.customSearch.push(search);
              }
            } else if (item.type == "text") {
              let search = {
                title: item.displayName,
                type: "input",
                requestKey: item.name,
                placeholder: "请输入",
              };
              this.customSearch.push(search);
            } else if (item.type == "provinceCity") {
              let search = {
                title: item.displayName,
                type: "cascader",
                requestKey: item.name,
                label: "name",
                value: "name",
                data: [{ name: "全部" }, ...item.valueVo],
              };
              this.customSearch.push(search);
            }
          }
          if (item.type == "imageUpload") {
            let tables = {
              title: item.displayName,
              type: "img",
              width: "120",
              prop: item.name,
            };
            this.tableHeader.push(tables);
          } else {
            let tables = {
              title: item.displayName,
              width: "120",
              prop: item.name,
            };
            this.tableHeader.push(tables);
          }
        });
        this.requestForm = Object.assign(this.requestForm, res.requestForm);
        this.teaSelectList = [...this.teaSelectList, ...this.customSearch];
      });
    
      getSelectPlanFn({ needAudit: 8 }).then(({ data }) => {
        this.$set(this.teaSelectList[0], "data", data);
        let planId = this.$route.query.planId;
        this.requestForm.planId = planId ? planId: data[0].id;
        this.getTableList();
        this.setCurrentPlanId();
      });
      this.mixin_getSelectSchool().then((data) => {
        let newSchoolList = [{ id: "", name: "全部" }, ...data];
        this.$set(this.teaSelectList[3], "data", newSchoolList);
      });
      this.mixin_getSelectStation().then((data) => {
        let newStationList = [{ id: "", name: "全部" }, ...data];
        this.$set(this.teaSelectList[4], "data", newStationList);
      });
      this.mixin_getSelectSubject().then((data) => {
        let newSubjectList = [{ id: "", name: "全部" }, ...data];
        this.$set(this.teaSelectList[6], "data", newSubjectList);
      });
      // 免考原因列表
      getReasonListAPI().then(({ data }) => {
        if (data && data.length>0) {
          this.teaSelectList.map(e=>{
            if (e.requestKey === "exemptReasonId") {
              let resultMap = data.filter(item => item.stopFlag == 0).map(item => {
                return {
                  id: item.reasonId,
                  name: item.reasonName
                }
              });
              e.data = e.data.concat(resultMap);
            }
          })
        }
      });
    },
    getPlanCourse(val){
      this.requestForm.courseId = ''
      getPlanCourseList({planId:val}).then((data)=>{
        let newSchoolList = [{courseId:'',courseName:'全部'},...data.data]
        this.$set(this.teaSelectList[6], "data", newSchoolList);
      })
    },
  
    // 当前批次
    async setCurrentPlanId() {
      const { data } = await getCurrentPlanFn({
        planId: this.requestForm.planId,
      })
      this.currentPlanId = data.id;
      this.planInfo = data;

    },
  },
};
</script>

<style lang="less" scoped>
.applyAudit {
  /deep/ .unDistributed {
    position: relative;
    margin-left: 10px;
    &:after {
      content: " ";
      position: absolute;
      left: -10px;
      top: 7px;
      width: 5px;
      height: 5px;
      background-color: #fe5958;
      border-radius: 50%;
    }
  }
  /deep/ .unFinish {
    position: relative;
    margin-left: 10px;
    &:after {
      content: " ";
      position: absolute;
      left: -10px;
      top: 7px;
      width: 5px;
      height: 5px;
      background-color: #006aff;
      border-radius: 50%;
    }
  }
  /deep/ .wait {
    position: relative;
    margin-left: 10px;
    &:after {
      content: " ";
      position: absolute;
      left: -10px;
      top: 7px;
      width: 5px;
      height: 5px;
      background-color: #f27900;
      border-radius: 50%;
    }
  }
  /deep/ .finish {
    position: relative;
    margin-left: 10px;
    &:after {
      content: " ";
      position: absolute;
      left: -10px;
      top: 7px;
      width: 5px;
      height: 5px;
      background-color: #1dbf60;
      border-radius: 50%;
    }
  }
}
.mainCon {
  padding: 20px;
  border-radius: 8px;
  background-color: #fff;
  flex: 1;
}
.showFile {
  &>li {
    display: flex; 
    align-items: center; 
    margin-top: 16px; 
    border: 1px dashed #CCC; 
    border-radius: 8px;
    cursor: pointer;
    &>img {
      width: 120px; 
      height: 120px;
    }
    &>p{
      margin-left: 16px;
    }
  }
}
</style>
